




import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { FilterComponentMixin } from '@/mixins/filter-component.mixin'
import { Moment } from 'moment'
import _ from 'lodash'

@Component
export default class RangePickerFilter extends mixins(FilterComponentMixin) {
  get value(): (Moment | undefined)[] {
    const { value } = this.filter
    const { $gte = null, $lte = null } = value || {}

    return [$gte ? this.$moment($gte).startOf('day') : undefined, $lte ? this.$moment($lte).endOf('day') : undefined]
  }

  set value(date: (Moment | undefined)[]) {
    if (_.isEmpty(date)) this.$set(this.filter, 'value', undefined)
    else {
      let [$gte, $lte] = date
      this.$set(this.filter, 'value', {
        $gte: ($gte && $gte.startOf('day')) || null,
        $lte: ($lte && $lte.endOf('day')) || null
      })
    }
  }
}
